module.exports = __webpack_public_path__ + "img/thumbnail_SiberianTiger_m_normal.0de12764.png";